<template src="./registration.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'

export default {
  name: "aggregatorRegister",
  data() {
    return {
      fileUrl: `${process.env.VUE_APP_API_URL}/file`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
        'Access-Control-Allow-Origin': '*',
      },
      ko : ko,
      amount: 0,
      aggregatorOption : [],
      aggregator : null,
      
      saleDate : null,
      taxDate : null,
      depositDate : null,
      item : null,
      
    }
  },
    mounted(){
      this.$nextTick(function(){
        this.callAggregator();
      })
    },
  computed: {
    
  },
  watch:{
      
  },
  methods: {
    allSave(){
      let payload ={
        aggregator_id: this.aggregator,
        month: this.saleDate,
        amount: Number(this.amount.replace(/,/gi, "")),
        tax_invoice_date: this.taxDate,
        deposit_date: this.depositDate,
        item : this.item,
        note : this.note
      }
      if(this.valCheck(this.aggregator)){
        this.alert({msg : '계약사를 선택해주세요.'})
        return false 
      }
      if(this.valCheck(this.amount)){
        this.alert({msg : '정산액을 입력해주세요.'})
        return false 
      }
      if(this.valCheck(this.saleDate)){
        this.alert({msg : '매출월을 입력해주세요.'})
        return false 
      }
      
      this.loadingShow();
      this.$store.dispatch('POST_SETTLEMENT', payload).then(result =>{
          this.loadingHide()
          this.$router.push('/taxinvoice')
          //페이지 수
      }).catch(error=>{
        const status = error.response.status
        this.loadingHide()
        switch(status){
            
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
                this.alert({msg : error.response.data.message})
            break;
        }
      })
    },
    callAggregator(){
      const option = {
          sort: 'created_at',
          sortorder: 'desc',
          //is_various_artists: false, // 필수 filter
      }
      
      let query = {}

      
      this.loadingShow()

      this.$store.dispatch('GET_AGGREGATOR', option).then(result =>{
          this.loadingHide()
          this.aggregatorOption  = result // 권리자 목록
          
          this.total = result.length // 총인원수 
          
          //페이지 수
      }).catch(error=>{
        const status = error.response.status
        this.loadingHide()
        switch(status){
            
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
                this.alert({msg : error.response.data.message})
            break;
        }
      })
    }
  },
    
}
</script>

<style scoped>

</style>